<app-header-title [hasBreadcrumbs]="true"> </app-header-title>
<div class="container-fluid px-3 pt-3">
  <div class="row g-3 masonry-container">
    <div class="col-1 m-0 masonry-sizer"></div>
    <!-- keep all the component tiles below this div -->

    <app-tile-bank-accounts
      [clientId]="clientId"
      class="col-12 col-xl-6"
    ></app-tile-bank-accounts>
    <app-investment-tile
      class="col-12 col-xl-6"
      [clientId]="clientId"
    ></app-investment-tile>
    <app-tile-debt
      class="col-12 col-xl-6"
      [clientId]="clientId"
    ></app-tile-debt>
  </div>
</div>
